const woodyHingeTypes = ['default', 'mv110', 'n3248', 'te541'];

export default woodyHingeTypes;
